<div class="disposal" on:click in:AnimIN out:AnimOUT class:notEnoughPoints={count*20 > $points}>
    Samainīt {count} {count>1?`kārtis`:`kārti`}!<br>
    Tas maksās {count*20} puntus! {count*20 > $points ? `Tev nav!` : ``}
</div>

<style>
div.disposal {
    font-size: 1em;
    padding: 0.5em 1.5em;
    border-radius: 2em;
    border: none;
    background: linear-gradient(45deg, var(--kilo) 0%, var(--mega) 100%);
    cursor: pointer;
    color: white;
}
div.disposal.notEnoughPoints {
    background: linear-gradient(45deg, var(--yotta) 0%, var(--zetta) 100%);
}
</style>

<script>
import { AnimIN, AnimOUT } from "../../code/anim.js"
import { points } from "../../stores/index.js"

export let count
</script>